export default __webpack_public_path__ + "static/media/sun-01.952bb50c.svg";